<template>
  <div>
    <!--Footer-->
    <div class="footer-1">
      <div class="opa-black">
        <h1>SUDAH SIAP MUAT KARGO ?</h1>
        <button
          class="btn btn-iklan mt-5"
          data-toggle="modal"
          data-target="#modalRegister"
        >
          Coba 7 hari gratis
        </button>
      </div>
    </div>

    <section
      id="about"
      class="footer-2"
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <img
            class="logo-zonasea"
            src="images/logo-white@4x.png"
            alt=""
          >
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-4">
          <h4 class="font-weight-bold mb-4">
            TENTANG KAMI
          </h4>
          <p
            class="text-footer"
            v-html="footerDesc"
          />
        </div>
        <div class="col-md-1" />
        <div class="col-md-3">
          <h4 class="font-weight-bold mb-4">
            SOCIAL MEDIA
          </h4>
          <ul>
            <li
              v-for="(item, index) in sosmed"
              :key="index"
            >
              <a
                :href="item.url"
                class="d-flex align-items-center mb-2"
              >
                <i
                  class="fa-2x mr-2"
                  :class="item.icon"
                />
                <span>{{ item.id }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-4 text-right">
          <h4 class="font-weight-bold mb-4">
            TEMUKAN KAMI
          </h4>
          <p class="mb-0">
            PT Global Solusi Maritim
          </p>
          <p class="text-footer">
            {{ address }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="copyright mt-5">
            <p class="mt-4 mb-0">
              {{ copyright }}
            </p>
          </div>
          <!-- <h5>{{ version }}</h5> -->
          <!-- <span><u>Term and Condition</u>&nbsp;</span>
          <span>&nbsp;<u>Privacy and Policy</u></span> -->
        </div>
      </div>
    </section>
    <!-- End Footer -->
  </div>
</template>

<script>
export default {
  name: "Footers",
  data () {
    return {
      version: process.env.VUE_APP_VERSION,
      footerDesc: 'Zonasea merupakan platform marketplace untuk mempertemukan pemilik kapal dengan pemilik muatan. Dengan menggunakan Zonasea, anda bisa berbisnis dengan tenang tanpa mengkhawatirkan legalitas perusahaan baik pemilik kapal maupun pemilik muatan dikarenakan semua member kami akan melalui tahap verifikasi oleh tim Zonasea.',
      address: 'Belleza Office Tower, 19th Floor - Unit 7, Jl. Letnan Jenderal Soepeno Jl. Permata Hijau No.34, North Grogol, Kebayoran Lama, South Jakarta City, Jakarta 12210',
      copyright: 'Copyright PT Global Solusi Maritim',
      sosmed :[
        {
          id: 'zona.sea',
          icon: 'fab fa-instagram',
          url: 'https://www.instagram.com/zona.sea/'
        },
        {
          id: 'zonasea',
          icon: 'fab fa-facebook-square',
          url: 'https://www.facebook.com/zonasea'
        },
        {
          id: 'zonasea',
          icon: 'fab fa-linkedin',
          url: 'https://www.linkedin.com/company/zonasea'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .footer-1 {
    font-family: $font-lato;
    background-image: url("/images/kapal.jpeg");
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-color: $primary-color;
    color: $white-color;
    text-align: center;

    .opa-black {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      background: rgba(0, 88, 129, 0.281);
      height: 500px;
      // width: 100%;
    }
  }

  .footer-2 {
    border-radius: 50px 50px 0 0;
    color: $white-color;
    background-color: $primary-color;
    padding: 5% 10% 2%;
    margin-top: -45px;

    ul {
      list-style: none;
      padding-inline-start: 0;

      li {
        a {
          color: white;
          text-decoration: none;
        }

        a:hover {
          color: whitesmoke;
        }
      }
    }

    .label-name {
      font-size: $font-size-lg;
      font-weight: $font-weight-md;
    }

    .logo-zonasea {
      width: 200px;
    }

    .text-footer {
      color: $white-color;
      // text-align: justify;
    }

    .copyright {
      margin-top: 3rem;
      text-align: center;
      color: #FFF;
      border-top: 1px solid $white-color;
      // border-radius: 15px;
      // margin: 0 20%;
    }
  }
</style>
